import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useRef } from 'react';
import SideNavBar from './SideNavBar';
import Equipment from '../nav logo/equipment-removebg-preview.png';

const Equipments = () => {
  const [contributions, setContributions] = useState([
    {
      name: 'Camera',
      category: 'Media',
      condition: 'Excellent',
    },
    {
      name: 'Drum',
      category: 'Musical',
      condition: 'Good',
    },
    {
      name: 'Laptop(Projecting)',
      category: 'Media',
      condition: 'Good',
    },
    {
      name: 'Laptop(Editing)',
      category: 'Media',
      condition: 'Excellent',
    },
    {
      name: 'KeyBoard',
      category: 'Good',
      condition: 'EXcellent',
    },
  ]);

  const handleDelete = index => {
    const updated = contributions.filter((_, i) => i !== index);
    setContributions(updated);
  };

  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved === 'true'; // Convert string to boolean
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();

  // Close sidebar when clicking outside (mobile)
  useEffect(() => {
    if (!sidebarOpen) return;
    function handleClick(e) {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sidebarOpen]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);
  return (
    <div
      className={darkMode ? 'dark bg-gray-900 min-h-screen h-full' : 'bg-white min-h-screen h-full'}
    >
      {/* Dark mode toggle */}
      <button
        className={`fixed top-4 right-4 z-50 border-2 border-green-700 rounded-full p-2 shadow-lg transition hover:bg-green-700 hover:text-white
           ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-white text-green-800'}`}
        onClick={() => setDarkMode(prev => !prev)}
        aria-label="Toggle dark mode"
      >
        {darkMode ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 4.95l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
            />
          </svg>
        )}
      </button>

      {/* Hamburger for mobile */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black shadow-lg transition-colors duration-300 hover:bg-green-700 hover:text-white"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div className="flex h-screen">
        {/* Desktop Sidebar */}
        <div
          className={`hidden md:block fixed top-0 left-0 h-screen w-52 overflow-y-auto bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar z-50`}
        >
          <SideNavBar darkMode={darkMode} />
        </div>

        {/* Mobile Sidebar Overlay */}
        {sidebarOpen && <div className="fixed inset-0 z-40 bg-black bg-opacity-40 md:hidden" />}

        {/* Mobile Sidebar */}
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 z-50 w-64 h-screen bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar transform transition-transform duration-300 md:hidden ${
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <div className="flex justify-between items-center mb-4">
            <span className="font-bold text-lg text-white">Menu</span>
            <button
              className="p-2 rounded-md bg-gray-200 dark:bg-gray-100"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <SideNavBar darkMode={darkMode} />
        </div>

        {/* Main Content */}
        <div className="flex-1 md:ml-52 overflow-y-auto p-4">
          <div
            className={`flex-1 p-6 transition-all duration-300 ${
              darkMode ? 'bg-gray-900' : 'bg-white'
            }`}
          >
            <div className="md:flex ml-7 md:justify-between">
              <div>
                <h1
                  className={`text-2xl font-bold md:text-left text-center mt-8 ${
                    darkMode ? 'text-yellow-200' : 'text-green-800'
                  }`}
                >
                  Equipments Management
                </h1>
                <p
                  className={`md:text-left text-center font-semibold mt-4 ${
                    darkMode ? 'text-green-200' : 'text-gray-700'
                  }`}
                >
                  Track and manage church equipments and assets efficiently.
                </p>
                {/* Add your equipment management components here */}
              </div>
              <div>
                <NavLink
                  className={` hover:scale-95  mt-8 text-center mx-auto  w-40 block hover:duration-700 hover:ease-out p-2 rounded-md ${
                    darkMode ? 'text-white bg-gray-700' : 'text-white bg-green-900'
                  }`}
                  to="/addequipment"
                >
                  <h1>Add Equipment</h1>
                </NavLink>
              </div>
            </div>
            <div
              className={`rounded-md  md:w-11/12 md:p-4 p-4 mt-4 md:ml-7 ${
                darkMode ? 'bg-gray-800 text-white' : 'bg-green-800 text-gray-800'
              }`}
            >
              <div className="md:flex md:justify-between">
                <div>
                  <h1
                    className={`text-2xl font-bold md:text-left text-center  ${
                      darkMode ? 'text-yellow-200' : 'text-white'
                    }`}
                  >
                    Equipment Dashboard
                  </h1>
                  <p
                    className={`md:text-left text-sm text-center font-semibold mt-4 ${
                      darkMode ? 'text-green-200' : 'text-white'
                    }`}
                  >
                    Manage and track all church equipment and assets efficiently
                  </p>
                </div>
                <div
                  className={`rounded-md  md:w-56 w-56 mx-auto md:mx-0 p-2 md:p-2 mt-5 md:mt-0 md:ml-7 ${
                    darkMode ? 'bg-gray-600 text-white' : 'bg-green-600 text-gray-800'
                  }`}
                >
                  <NavLink className="flex gap-2">
                    <div>
                      <img src={Equipment} className="w-10 h-10" alt="" />
                    </div>
                    <div>
                      <h1
                        className={` font-bold md:text-left mt-2 text-center  ${
                          darkMode ? 'text-white' : 'text-white'
                        }`}
                      >
                        Total Equipment: 5
                      </h1>
                    </div>
                  </NavLink>
                </div>
              </div>
              <div className="w-full md:w-auto flex flex-wrap mt-4 md:items-start gap-3 ml-4 md:ml-0 justify-start ">
                <NavLink to="/equipmentinventory">
                  <span className="text-xs text-green-800 font-bold p-2 rounded-md bg-white">
                    View Inventory
                  </span>
                </NavLink>
                <NavLink>
                  <span className="text-xs text-green-800 font-bold p-2 rounded-md bg-gray-200">
                    Maintenance
                  </span>
                </NavLink>
                <NavLink>
                  <span className="text-xs text-green-800 font-bold p-2 rounded-md bg-gray-200">
                    Reports
                  </span>
                </NavLink>
              </div>
            </div>
            <div
              className={`rounded-md md:flex md:gap-6 md:space-y-0 space-y-3 p-4  shadow-2xl mt-8 md:w-11/12 ml-7 ${
                darkMode ? 'bg-gray-800' : 'bg-white'
              }`}
            >
              <div className="bg-gradient-to-r from-blue-500 to to-blue-700 p-4  mx-auto md:mx-0 rounded-md hover:scale-110 hover:ease-in-out hover:duration-1000">
                <h1 className="text-xl md:text-sm font-bold text-white">Total Equipment</h1>
                <p className="text-xl font-bold text-white">5</p>
              </div>
              <div className="bg-gradient-to-r from-green-500 to to-green-700 p-4  mx-auto md:mx-0 rounded-md hover:scale-110 hover:ease-in-out hover:duration-1000">
                <h1 className="text-xl md:text-sm font-bold text-white">Excellent Condition</h1>
                <p className="text-xl font-bold text-white">3</p>
              </div>
              <div className="bg-gradient-to-r from-blue-300 to to-blue-500 p-4  mx-auto md:mx-0 rounded-md hover:scale-110 hover:ease-in-out hover:duration-1000">
                <h1 className="text-xl md:text-sm font-bold text-white">Good Condition</h1>
                <p className="text-xl font-bold text-white">2</p>
              </div>
              <div className="bg-gradient-to-r from-orange-500 to to-orange-700 p-4  mx-auto md:mx-0 rounded-md hover:scale-110 hover:ease-in-out hover:duration-1000">
                <h1 className="text-xl md:text-sm font-bold text-white">Needs Attention</h1>
                <p className="text-xl font-bold text-white">0</p>
              </div>
              <div className="bg-gradient-to-r from-purple-500 to to-purple-700 p-4  mx-auto md:mx-0 rounded-md hover:scale-110 hover:ease-in-out hover:duration-1000">
                <h1 className="text-xl md:text-sm font-bold text-white">Recent Maintanance</h1>
                <p className="text-xl font-bold text-white">0</p>
              </div>
            </div>
            <div className="flex-1 overflow-x-auto overflow-y-auto p-4 mx-auto md:mx-0 w-72 md:ml-4 ml-4 md:w-full ">
              <table className="w-11/12 md:w-11/12 text-gray-700 font-bold text-sm text-left border-collapse min-w-[600px]">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="p-2 border-b">NAME</th>
                    <th className="p-2 border-b">CATEGORY</th>
                    <th className="p-2 border-b">CONDITION</th>
                    <th className="p-2 border-b">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {contributions.map((contribution, index) => (
                    <tr key={index} className="hover:bg-gray-100 bg-white hover:duration-700">
                      <td className="p-2 border-b">{contribution.name}</td>
                      <td className="p-2 border-b">{contribution.category}</td>
                      <td className="p-2 border-b">{contribution.condition}</td>

                      <td className="p-2 border-b">
                        <button
                          onClick={() => handleDelete(index)}
                          className="hover:scale-110 transition-transform"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0,0,256,256"
                            fill="#FA5252"
                          >
                            <g transform="scale(10.66667,10.66667)">
                              <path d="M9.07617,2l-0.5,3h-0.57617h-4.05664l-0.00781,-0.05664l-0.46484,0.05664h-0.9707h-0.5v1h0.5h0.55664l1.94336,16h14l1.94336,-16h0.55664h0.5v-1h-0.5h-0.9707l-0.46484,-0.05664l-0.00781,0.05664h-4.02148h-0.03516h-0.57617l-0.5,-3zM9.92383,3h4.15234l0.33398,2h-4.82031zM4.06445,6h3.90039h1.45898h5.15234h1.42383h3.93555l-1.82227,15h-12.22656zM6.93359,8.94141l-0.99219,0.125l0.0625,0.49609l1,8l0.0625,0.49609l0.99219,-0.125l-0.0625,-0.49609l-1,-8zM17.06641,8.94141l-0.0625,0.49609l-1,8l-0.0625,0.49609l0.99219,0.125l0.0625,-0.49609l1,-8l0.0625,-0.49609zM10,9v0.5v8v0.5h1v-0.5v-8v-0.5zM13,9v0.5v8v0.5h1v-0.5v-8v-0.5z" />
                            </g>
                          </svg>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="bg-gray-200">
                    <td colSpan="6" className="p-2 text-center">
                      Total Records: {contributions.length}
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Equipments;
